var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { SecondaryText } from "../../designSystem";
import colors from "../../designSystem/colors";
import theme from "../../designSystem/theme";
var HelpContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 16px;\n  width: 16px;\n  border: ", " ", "\n    ", ";\n  border-radius: 100px;\n  margin-left: 8px;\n  z-index: 1;\n  text-transform: none;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 16px;\n  width: 16px;\n  border: ", " ", "\n    ", ";\n  border-radius: 100px;\n  margin-left: 8px;\n  z-index: 1;\n  text-transform: none;\n"])), theme.border.width, theme.border.style, function (props) { return (props.color ? props.color : colors.borderLight); });
var HelpInfo = function (_a) {
    var children = _a.children, containerRef = _a.containerRef, color = _a.color, props = __rest(_a, ["children", "containerRef", "color"]);
    return (_jsx(HelpContainer, __assign({ color: color }, props, { ref: containerRef }, { children: _jsx(SecondaryText, __assign({ fontSize: 10, lineHeight: 12, color: color || colors.text }, { children: children }), void 0) }), void 0));
};
export default HelpInfo;
var templateObject_1;
//# sourceMappingURL=HelpInfo.js.map